// extracted by mini-css-extract-plugin
module.exports = {"appeals_wrapper":"appeals_appeals_wrapper__3pXr4","appeals_wrapper_title":"appeals_appeals_wrapper_title__2j809","appeals_wrapper_content":"appeals_appeals_wrapper_content__3kyvP"};